<template>
  <div>
    <slot></slot>

    <!--<div class="form__label selector">-->
      <!--<h3 class="selector__title">Styles</h3>-->
    <!--</div>-->

    <dress-grid v-if="clothes.length" :items="clothes"></dress-grid>
    <!--<carousel-selector v-if="clothes.length" :items="clothes" carousel="dress-carousel" title="Mise"></carousel-selector>-->

    <!--<carousel-selector :items="clothesBySlot('bottom')" carousel="dress-carousel" title="Under"></carousel-selector>-->

    <!--<carousel-selector :items="clothesBySlot('accessories')" carousel="dress-carousel" title="Accessories"></carousel-selector>-->

  </div>
</template>

<script>

  import { mapGetters } from 'vuex';
  import DressGrid from '../partials/DressGrid'
  // import CarouselSelector from '../selectors/CarouselSelector';
  import 'vueperslides/dist/vueperslides.css'

  export default {
    name: "TabImageModel",
    components: {
      // CarouselSelector,
      DressGrid
    },
    computed: {
      ...mapGetters('clothes',[
        'clothes',
        'clothesBySlot'
      ]),
      ...mapGetters('fabrics',[
        'fabrics'
      ]),
      ...mapGetters('clothes',[
        'selectedMesh'
      ]),
      // topClothes: () => this.clothesBySlot('top'),
    }
  }
</script>

<style scoped>
  .slide-up-enter-active {
    transition: all .6s ease-in-out;
  }
  .slide-up-leave-active {
    transition: all .6s ease-in-out;
  }
  .slide-up-enter, .slide-up-leave-to
    /* .slide-fade-leave-active below version 2.1.8 */ {
    transform: translateY(30px);
    opacity: 0;
  }

</style>